import { Box, IconButton, Typography, Chip } from "@mui/material";
import CustomDataGrid from "src/@core/components/data-grid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Visibility, Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

function TableRegions({
  rows,
  totalCount,
  setCurrentPage,
  currentPage,
  setPageSize,
  pageSize,
  loading,
  toggleEdit,
  toggleStatus,
  toggleDelete,
}) {
  const navigate = useNavigate();
  const statusColors = {
    Active: "#66bb6a",
    Inactive: "#FFB400",
  };
  const CustomChip = styled(Chip)(({ label }) => ({
    backgroundColor: statusColors[label] || "#666",
    color: "#fff",
    width: "100px",
    textTransform: "capitalize",
  }));

  const rowsWithSrNo = rows.map((row, index) => ({
    ...row,
    srNo: (currentPage - 1) * pageSize + index + 1,
  }));

  return (
    <CustomDataGrid
      getRowId={(row) => row.id}
      loading={loading}
      rowCount={totalCount}
      rows={rowsWithSrNo}
      columns={[
        { field: "srNo", headerName: "Sr No", minWidth: 100, sortable: false },
        {
          field: "name",
          headerName: "Name",
          minWidth: 250,
          sortable: false,
          renderCell: ({ row }) => (
            <Typography noWrap variant="body2" textTransform="capitalize">
              {row.name} 
            </Typography>
          ),
        },
        {
          field: "is_active",
          headerName: "Status",
          minWidth: 150,
          sortable: false,
          renderCell: ({ row }) => <CustomChip
            label={row.is_active ? "Active" : "Inactive"}
            onClick={() => toggleStatus(row)}
          />,
        },
        {
          field: "Actions",
          headerName: "Actions",
          minWidth: 200,
          sortable: false,
          renderCell: ({ row }) => {
            const isDeleted = row.status === 2;
            const disabledStyle = { color: "#B0B0B0" };
            return (
              <Box display="flex" gap="10px">
                <IconButton
                  size="small"
                  color="primary"
                  onClick={(e) => toggleEdit(e, row)}
                  disabled={isDeleted}
                >
                  <Edit sx={isDeleted ? disabledStyle : {}} />
                </IconButton>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={(e) => toggleDelete(e, row)}
                  disabled={isDeleted}
                >
                  <DeleteIcon sx={isDeleted ? disabledStyle : {}} />
                </IconButton>
                {/* <IconButton
                  size="small"
                  color="primary"
                
                  disabled={isDeleted}
                >
                  <MoreVertIcon sx={isDeleted ? disabledStyle : {}} />
                </IconButton> */}
              </Box>
            );
          },
        },
      ]}
      currentPage={currentPage}
      pageSize={pageSize}
      setCurrentPage={setCurrentPage}
      setPageSize={setPageSize}
    />
  );
}

export default TableRegions;